<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/simple'
import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'

export default {
  page: {
    title: 'Dashboard',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    OilVolumeChange: () => import('../reports/views/OilVolumeChange'),
    CurrentUsageOfOilOnAMap: () =>
      import('../reports/views/CurrentUsageOfOilOnAMap'),
    AverageOilUsageDuringATimePeriodByOilType: () =>
      import('../reports/views/AverageOilUsageDuringATimePeriodByOilType'),
    UnresponsiveTransmittersAndPlugs: () =>
      import('../reports/views/UnresponsiveTransmittersAndPlugs'),
  },
  data() {
    return {
      widgets: [
        {
          reportName: 'OilVolumeChange',
          params: {
            aspectRatio: 2.0,
            granularity: 'day',
            start_date: this.weekAgo(),
            end_date: this.today(),
          },
          dateLabel: this.getDateRange(),
        },
        {
          reportName: 'CurrentUsageOfOilOnAMap',
          params: {},
        },
        {
          reportName: 'AverageOilUsageDuringATimePeriodByOilType',
          params: {
            period: 7,
            start_date: this.weekAgoDateParam(),
            end_date: this.todayDateParam(),
          },
          dateLabel: this.getDateRange(),
        },
        {
          reportName: 'UnresponsiveTransmittersAndPlugs',
          params: 7,
          dateLabel: this.getDateSince(),
        },
      ],
    }
  },
  watch: {
    '$i18n.locale': function(newVal, oldVal) {
      let report = this.widgets.find(
        rep => rep.reportName === 'UnresponsiveTransmittersAndPlugs'
      )
      if (report) {
        report.dateLabel = this.getDateSince()
      }
    },
  },
  methods: {
    today() {
      return moment().endOf('day')
    },
    todayDateParam() {
      return this.today().format('YYYY-MM-DD')
    },
    todayDate() {
      return this.today().format('YYYY-MM-DD')
    },
    weekAgo() {
      return moment()
        .add(-7, 'day')
        .startOf('day')
    },
    weekAgoDateParam() {
      return this.weekAgo().format('YYYY-MM-DD')
    },
    weekAgoDate() {
      return this.weekAgo().format('YYYY-MM-DD')
    },
    getDateRange() {
      return this.weekAgoDate() + ' - ' + this.todayDate()
    },
    getDateSince() {
      return this.$t('label__since') + ' ' + this.weekAgoDate()
    },
    navigateToReport(reportName) {
      const reportConfig = this.widgets.find(
        elem => elem.reportName === reportName
      )
      this.$store.commit('settings/SET_SETTINGS', {
        name: reportName,
        params: cloneDeep(reportConfig.params),
      })
      if (reportConfig) {
        this.$router.push({
          path: `/reports/${reportConfig.reportName}`,
        })
      }
    },
    getSettingsFromStore(reportName) {
      return this.$store.state.settings.settings[reportName]
    },
  },
}
</script>

<template>
  <Layout>
    <v-layout
      row
      wrap>
      <v-flex 
        v-for="widget in widgets"
        :key="widget.reportName"
        lg6 
        xs12 
        class="pb-3 pl-3">
        <v-flex class="pb-3">
          <a 
            style="text-decoration: underline" 
            @click="navigateToReport(widget.reportName)">{{
              $t(`reports__${widget.reportName}`)
            }}</a>
          {{ widget.dateLabel }}
        </v-flex>
        <component
          :ref="widget.reportName"
          :is="widget.reportName"
          :ext-params="widget.params"
          :style="[widget.reportName === 'CurrentUsageOfOilOnAMap' ? {'zoom': '100%'} : {'zoom': '90%'}]"
        />
      </v-flex>
    </v-layout>
  </Layout>
</template>
